// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation, useRequest } from "redux-query-react";
import { useSelector } from 'react-redux';
import * as QueryString from 'query-string';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { PrivateBenchmarkResponseFromJSON, } from '../models';
/**
 * Delete Benchmark with Id
 */
export function deletePrivatebenchmarkIdRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deletePrivatebenchmarkId.');
    }
    if (requestParameters.isCustom === null || requestParameters.isCustom === undefined) {
        throw new runtime.RequiredError('isCustom', 'Required parameter requestParameters.isCustom was null or undefined when calling deletePrivatebenchmarkId.');
    }
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.isCustom !== undefined) {
        queryParameters['isCustom'] = requestParameters.isCustom;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/privatebenchmark/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            PrivateBenchmark: (prevValue, transformedValue) => {
                const updateValue = { ...prevValue };
                delete updateValue[requestParameters.id];
                return updateValue;
            }
        },
        optimisticUpdate: requestConfig.optimisticUpdate || {
            PrivateBenchmark: (prevValue) => {
                const optimisticValue = { ...prevValue };
                delete optimisticValue[requestParameters.id];
                return optimisticValue;
            }
        },
        rollback: requestConfig.rollback || {
            PrivateBenchmark: (initialValue, currentValue) => {
                const rollbackValue = { ...currentValue };
                rollbackValue[requestParameters.id] = initialValue[requestParameters.id];
                return rollbackValue;
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'DELETE',
            headers: headerParameters,
        },
        body: queryParameters,
    };
    config.queryKey = requestConfig.queryKey || `DeletePrivatebenchmarkId-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Delete Benchmark with Id
*/
/**
 * Mutation hook for deleting a PrivateBenchmark, with optimistic update and optimized rollback in case of failure.
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to delete a PrivateBenchmark
 */
export const useDeletePrivatebenchmarkId = (customQueryConfig) => {
    return useMutation((id, isCustom, customQueryParam) => deletePrivatebenchmarkId({ id, isCustom }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function deletePrivatebenchmarkId(requestParameters, requestConfig) {
    return deletePrivatebenchmarkIdRaw(requestParameters, requestConfig);
}
/**
 * Get a Private Benchmark by Id
 * Get private benchmark by id
 */
export function getPrivatebenchmarkIdRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getPrivatebenchmarkId.');
    }
    if (requestParameters.isCustom === null || requestParameters.isCustom === undefined) {
        throw new runtime.RequiredError('isCustom', 'Required parameter requestParameters.isCustom was null or undefined when calling getPrivatebenchmarkId.');
    }
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.isCustom !== undefined) {
        queryParameters['isCustom'] = requestParameters.isCustom;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.codes !== undefined) {
        queryParameters['codes'] = requestParameters.codes;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/privatebenchmark/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            PrivateBenchmark: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = PrivateBenchmarkResponseFromJSON(body);
            let key = "";
            if (requestParameters.id) {
                key = `${key}${requestParameters.id}`;
            }
            if (requestParameters.isCustom) {
                key = `${key}${requestParameters.isCustom}`;
            }
            if (requestParameters.codes) {
                key = `${key}${requestParameters.codes}`;
            }
            return { PrivateBenchmark: { [key]: objResponse } };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetPrivatebenchmarkId-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Get a Private Benchmark by Id
* Get private benchmark by id
*/
/**
 * Use this selector to get a reference to a single PrivateBenchmarkResponse matching the id
 * @param id Id of the PrivateBenchmarkResponse
 * @returns The PrivateBenchmarkResponse object
 */
export const usePrivateBenchmarkByIdSelector = (id, isCustom, codes) => {
    let key = "";
    if (id) {
        key = `${key}${id}`;
    }
    if (isCustom) {
        key = `${key}${isCustom}`;
    }
    if (codes) {
        key = `${key}${codes}`;
    }
    return useSelector((state) => state.entities.PrivateBenchmark[key], isEqual);
};
/**
 * Request hook for a single PrivateBenchmarkResponse. Beware, this should not be called without a valid id ***WIP***
 * @param id id of the PrivateBenchmarkResponse
 * @returns an array containing the data, query state, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetPrivatebenchmarkId = (requestParameters, customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getPrivatebenchmarkIdRaw(requestParameters, customQueryConfig));
    return [
        usePrivateBenchmarkByIdSelector(requestParameters.id, requestParameters.isCustom, requestParameters.codes),
        querystate,
        forceRefresh
    ];
};
export function getPrivatebenchmarkId(requestParameters, requestConfig) {
    return getPrivatebenchmarkIdRaw(requestParameters, requestConfig);
}
